import { render, staticRenderFns } from "./shared-tokens.vue?vue&type=template&id=25678fe8&scoped=true"
import script from "./shared-tokens.vue?vue&type=script&lang=js"
export * from "./shared-tokens.vue?vue&type=script&lang=js"
import style0 from "./shared-tokens.vue?vue&type=style&index=0&id=25678fe8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25678fe8",
  null
  
)

export default component.exports